import { create } from "zustand";

const useShaderManager = create((set) => ({
  fragCode: "",
  yState: null,
  vedaRef: null,
  errors: [],
  editorRef: null,
  showEditor: true,
  resolveError: (id) =>
    set((state) => {
      const errors = state.errors;
      var removeIndex = array.map((e) => e.id).indexOf(id);
      if (removeIndex > 0) {
        errors.splice(removeIndex, 1);
      }

      console.log("Resolved error :", errors);

      return {
        ...state,
      };
    }),
  addError: (result) =>
    set((state) => {
      const errors = state.errors;
      errors.push(result);

      console.log("Errors handlers:", errors);

      return {
        ...state,
      };
    }),
  update: (key, value) =>
    set((state) => {
      //console.log("Updating...", key)
      return {
        ...state,
        [key]: value,
      };
    }),
  checkpoint1: `precision mediump float;
   uniform float time;
   uniform vec2 mouse;
   uniform vec2 resolution;
   
   void main() {
       vec2 uv = gl_FragCoord.xy / resolution.xy;
       gl_FragColor = vec4(uv,0.0,1.0);
   }`,
}));

export default useShaderManager;
